/* ─────────────────────────────────────────────────────────────────────
   The Pack — Cookie Consent
   Self-managed banner on top of Shopify's Customer Privacy API
   and Google Consent Mode v2.
   ───────────────────────────────────────────────────────────────────── */

(function () {
  if (window.__tpaConsentInit) return;
  window.__tpaConsentInit = true;

  /* ── Configuration ──────────────────────────────────────────────────
     Add a category here to extend the banner. Each category maps to:
       - Google Consent Mode v2 flags (gcm)
       - Shopify Customer Privacy keys (shopify)
     Note: 'essential' is hard-coded as always-granted; do not move it.
  ─────────────────────────────────────────────────────────────────── */
  var CATEGORIES = [
    {
      id: 'essential',
      essential: true
    },
    {
      id: 'analytics_marketing',
      gcm: ['ad_storage', 'analytics_storage', 'ad_user_data', 'ad_personalization'],
      shopify: { analytics: true, marketing: true, preferences: true, sale_of_data: true }
    }
    /* Future categories examples:
    {
      id: 'preferences',
      gcm: ['functionality_storage'],
      shopify: { preferences: true }
    },
    {
      id: 'marketing',
      gcm: ['ad_storage', 'ad_user_data', 'ad_personalization'],
      shopify: { marketing: true, sale_of_data: true }
    }
    */
  ];

  /* EU/EEA + UK + Switzerland — banner regions. Outside these, the user's
     country either has no requirement or already auto-accepts. Adjust if
     you ever expand to other strict-consent jurisdictions (e.g. Brazil LGPD
     could be added by including 'BR'). */
  var BANNER_COUNTRIES = new Set([
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE',
    'IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE',
    'IS','LI','NO',          /* EEA non-EU */
    'GB',                    /* UK */
    'CH'                     /* Switzerland — separate but follows GDPR-like */
  ]);

  var STORAGE_KEY = 'tpa_consent_v1';
  var CHANGE_EVENT = 'tpa:consent-change';

  /* ── Shopify Customer Privacy bootstrap ─────────────────────────── */
  function whenShopifyPrivacyReady(cb) {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) { if (!err) cb(); }
      );
    } else {
      /* Shopify.loadFeatures not yet defined — try again briefly */
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (window.Shopify && window.Shopify.loadFeatures) {
          clearInterval(iv);
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            function (err) { if (!err) cb(); }
          );
        } else if (tries > 40) {
          clearInterval(iv);
        }
      }, 100);
    }
  }

  /* ── State persistence ──────────────────────────────────────────── */
  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) { /* fall through */ }
    return null;
  }

  function writeState(categoriesObj) {
    var state = { version: 1, ts: Date.now(), categories: categoriesObj };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    return state;
  }

  function defaultCategoriesAllDenied() {
    var out = {};
    for (var i = 0; i < CATEGORIES.length; i++) {
      out[CATEGORIES[i].id] = !!CATEGORIES[i].essential;
    }
    return out;
  }

  function defaultCategoriesAllGranted() {
    var out = {};
    for (var i = 0; i < CATEGORIES.length; i++) {
      out[CATEGORIES[i].id] = true;
    }
    return out;
  }

  /* ── Apply consent to all sinks ─────────────────────────────────── */
  function applyConsent(categoriesObj) {
    /* 1. Google Consent Mode v2 update */
    var gcm = {};
    for (var i = 0; i < CATEGORIES.length; i++) {
      var cat = CATEGORIES[i];
      if (!cat.gcm) continue;
      var allowed = !!categoriesObj[cat.id];
      for (var j = 0; j < cat.gcm.length; j++) {
        gcm[cat.gcm[j]] = allowed ? 'granted' : 'denied';
      }
    }
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', gcm);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(['consent', 'update', gcm]);
    }

    /* 2. Shopify Customer Privacy API */
    whenShopifyPrivacyReady(function () {
      var consent = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      for (var i = 0; i < CATEGORIES.length; i++) {
        var cat = CATEGORIES[i];
        if (!cat.shopify || !categoriesObj[cat.id]) continue;
        for (var key in cat.shopify) {
          if (cat.shopify[key]) consent[key] = true;
        }
      }
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      } catch (e) {}
    });

    /* 3. DataLayer event for GTM custom triggers */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'tpa_consent_update', categories: categoriesObj });

    /* 4. Public DOM event */
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { categories: categoriesObj } }));
  }

  /* ── Banner + modal control ─────────────────────────────────────── */
  function getBanner()      { return document.getElementById('tpa-cookie-banner'); }
  function getModal()       { return document.getElementById('tpa-cookie-modal'); }
  function getSettingsBtn() { return document.getElementById('tpa-cookie-settings-btn'); }

  function showBanner() {
    var el = getBanner();
    if (el) el.removeAttribute('hidden');
    hideSettingsBtn();
  }
  function hideBanner() {
    var el = getBanner();
    if (el) el.setAttribute('hidden', '');
    showSettingsBtn();
  }
  function showSettingsBtn() {
    var el = getSettingsBtn();
    if (el) el.removeAttribute('hidden');
  }
  function hideSettingsBtn() {
    var el = getSettingsBtn();
    if (el) el.setAttribute('hidden', '');
  }
  function openModal() {
    var modal = getModal();
    if (!modal) return;
    /* Sync toggle state with current stored choice (or denied defaults) */
    var state = readState();
    var current = state ? state.categories : defaultCategoriesAllDenied();
    var toggles = modal.querySelectorAll('[data-tpa-cat]');
    for (var i = 0; i < toggles.length; i++) {
      var t = toggles[i];
      var id = t.getAttribute('data-tpa-cat');
      if (t.disabled) continue; /* essential always on */
      t.checked = !!current[id];
    }
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
  }
  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
  }

  function setAndPersist(categoriesObj) {
    writeState(categoriesObj);
    applyConsent(categoriesObj);
    hideBanner();
    closeModal();
  }

  /* ── Public API ─────────────────────────────────────────────────── */
  window.tpaConsent = {
    get: function () { return readState(); },
    set: setAndPersist,
    accept: function () { setAndPersist(defaultCategoriesAllGranted()); },
    reject: function () { setAndPersist(defaultCategoriesAllDenied()); },
    openPreferences: openModal,
    closePreferences: closeModal,
    isInBannerRegion: function () {
      var country = window.tpaConsentCountry || '';
      return BANNER_COUNTRIES.has(String(country).toUpperCase());
    }
  };

  /* ── Init ───────────────────────────────────────────────────────── */
  function init() {
    var state = readState();
    var inRegion = window.tpaConsent.isInBannerRegion();

    if (state) {
      /* Returning visitor — re-apply (mostly a no-op since the snippet
         already did the gtag update synchronously, but this also pushes
         to Shopify API + dataLayer event). */
      applyConsent(state.categories);
      hideBanner();
      return;
    }

    if (!inRegion) {
      /* Non-EU/EEA/UK — auto-grant and never show the banner. */
      var granted = defaultCategoriesAllGranted();
      writeState(granted);
      applyConsent(granted);
      hideBanner();
      return;
    }

    /* First-time EU visitor — banner needs to show. Apply nothing yet
       (defaults already denied via the snippet). */
    showBanner();
  }

  /* ── Wire up DOM ────────────────────────────────────────────────── */
  function wireBanner() {
    var banner = getBanner();
    var modal  = getModal();
    if (!banner) return;

    banner.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tpa-action]');
      if (!t) return;
      var action = t.getAttribute('data-tpa-action');
      if (action === 'accept') window.tpaConsent.accept();
      else if (action === 'reject') window.tpaConsent.reject();
      else if (action === 'customize') openModal();
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        var t = e.target.closest('[data-tpa-action]');
        if (!t) return;
        var action = t.getAttribute('data-tpa-action');
        if (action === 'save') {
          var toggles = modal.querySelectorAll('[data-tpa-cat]');
          var picked = defaultCategoriesAllDenied(); /* essentials = true */
          for (var i = 0; i < toggles.length; i++) {
            var tg = toggles[i];
            var id = tg.getAttribute('data-tpa-cat');
            picked[id] = !!tg.checked || !!tg.disabled;
          }
          setAndPersist(picked);
        } else if (action === 'accept') window.tpaConsent.accept();
        else if (action === 'reject') window.tpaConsent.reject();
        else if (action === 'close') closeModal();
      });

      /* Click outside modal content closes */
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    /* Footer "Cookie settings" link convention: any element with
       data-tpa-open-cookie-prefs anywhere on the page opens the modal. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-tpa-open-cookie-prefs]');
      if (!t) return;
      e.preventDefault();
      openModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wireBanner(); init(); });
  } else {
    wireBanner();
    init();
  }
})();
